import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Laptop, ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

export const RemoteWork = () => {
  const { t } = useTranslation();

  return (
    <section data-testid="remote-section" className="py-20 md:py-28 bg-ink text-sand overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 md:flex items-end justify-between gap-12">
        <Reveal className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.35em] text-terracotta mb-4 flex items-center gap-2">
            <Laptop size={16} /> {t("remote.kicker")}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl leading-[1.05]">{t("remote.title")}</h2>
          <p className="mt-5 text-sand/70 font-light text-base md:text-lg leading-relaxed">{t("remote.text")}</p>
        </Reveal>
        <Reveal delay={0.1} className="shrink-0">
          <Link
            data-testid="remote-whatsapp-btn"
            to="/estancias-largas"
            className="mt-8 md:mt-0 inline-flex items-center gap-2 px-8 py-4 border border-sand/30 text-sand text-xs uppercase tracking-[0.2em] hover:border-terracotta hover:text-terracotta transition-colors"
          >
            {t("remote.cta")} <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
